declare const domainIdBrand: unique symbol;

type BrandedId<Name extends string> = string & {
  readonly [domainIdBrand]: Name;
};

export type ProfileId = BrandedId<'ProfileId'>;
export type RoutineTemplateId = BrandedId<'RoutineTemplateId'>;
export type RoutineStepTemplateId = BrandedId<'RoutineStepTemplateId'>;
export type DailyRoutineId = BrandedId<'DailyRoutineId'>;
export type DailyStepId = BrandedId<'DailyStepId'>;
export type WorkoutSessionId = BrandedId<'WorkoutSessionId'>;
export type JournalEntryId = BrandedId<'JournalEntryId'>;
export type PhilosophyEntryId = BrandedId<'PhilosophyEntryId'>;
export type ExerciseLogId = BrandedId<'ExerciseLogId'>;
export type EmotionalProtocolLogId = BrandedId<'EmotionalProtocolLogId'>;
export type AppPreferencesId = BrandedId<'AppPreferencesId'>;
export type BackupMetadataId = BrandedId<'BackupMetadataId'>;

export type DomainId =
  | ProfileId
  | RoutineTemplateId
  | RoutineStepTemplateId
  | DailyRoutineId
  | DailyStepId
  | WorkoutSessionId
  | JournalEntryId
  | PhilosophyEntryId
  | ExerciseLogId
  | EmotionalProtocolLogId
  | AppPreferencesId
  | BackupMetadataId;

export function asDomainId<Id extends DomainId>(value: string): Id {
  return value as Id;
}
